'use client';

import React, { useEffect, useState } from 'react';
import { createClient } from '@/lib/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import WelcomeModal from './WelcomeModal';

export default function WelcomeGate() {
  const { user, loading } = useAuth();
  const supabase = createClient();
  const [showWelcome, setShowWelcome] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (loading || !user?.id) return;

    async function checkWelcome() {
      const { data } = await supabase
        .from('user_preferences')
        .select('has_seen_welcome')
        .eq('user_id', user!.id)
        .single();

      if (!data || !data.has_seen_welcome) {
        setShowWelcome(true);
      }
      setChecked(true);
    }

    checkWelcome();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, loading]);

  if (!checked || !showWelcome) return null;

  return <WelcomeModal onClose={() => setShowWelcome(false)} />;
}
